<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Loader from "@/components/widgets/loader";
import apibtoast from "@/helpers/apibtoast";
import apigeneric from "@/helpers/apigeneric";
import AddEdit from "./addedit.vue";
import mznfirma from "@/models/mznfirma";
import register from "@/models/register";
import Swal from "sweetalert2";

export default {
  mixins: [apibtoast, apigeneric, mznfirma,register],
  page: {
    title: "Firmalar",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Loader,
    Layout,
    PageHeader,
    AddEdit,
  },
  data() {
    return {
      title: this.$t("mznfirma.Title"),
      items: [
        {
          text: this.$t("mznfirma.Page.Anasayfa"),
          href: "/",
        },
        {
          text: this.$t("mznfirma.Page.UstMenu"),
          active: true,
        },
        {
          text: this.$t("mznfirma.Title"),
          active: true,
        },
      ],
      DefaultPage: 1,
      Page: {
        PageNumber: "1",
        PageSize: "10",
        PageDataSize: "1",
      },
      TableData: {},
      DataUpdate: "",
      AddEdit: "",
      FilterFirmaadi: "",
    };
  },
  methods: {
    FirmaOnay(Data){
      var FormData = this.registerData
      FormData.FirstName= Data.Firmaadi 
      FormData.Email= Data.Email
      FormData.UserName= Data.Email
      FormData.LastName= Data.Firmaadi
      FormData.Password= Data.Vergino.toString().substr(0,5)+Data.Firmaadi.substr(0,3)+'.';
      FormData.ConfirmPassword= Data.Vergino.toString().substr(0,5)+Data.Firmaadi.substr(0,3)+'.';
      this.Post(this.$config.API_ACCOUNT_URL_2+"Account/register", FormData,this.$t("mznfirma.Page.OnayMessage")).then((res) => {
            if (res) {
              Data.Userid=res
              Data.Onay=true
              this.Update(this.$config.API_URL_2+"mznfirma", Data) 
            }
          });

    },
    UserDelete(Data){ 
      Swal.fire({
        title: this.$t("ToasMessage.DeletePopupBaslik"),
        text: this.$t("ToasMessage.DeletePopupContent"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: this.$t("ToasMessage.DeletePopupPozitif"),
        cancelButtonText: this.$t("ToasMessage.DeletePopupNegatif"),
      }).then((result) => {
        if (result.value) {
          this.ActionsDelete({ Service: this.$config.API_URL_2+"mznfirma", Id: Data.Id }).then((res) => {
            if (res.Succeeded == true) {
              this.Get();
                  this.$toast.success(this.$t("ToasMessage.DeletePozitif"));
                  this.ActionsDelete({Service: this.$config.API_ACCOUNT_URL_2+"Account", Id: Data.Userid}).then((res) => {
                    if(res.Succeeded == true){
                      this.Get();
                    }
      });
  
              
            } else {
              this.$toast.error(this.$t("ToasMessage.DeleteNegatif"));
            }
          });
        }
      });
        },
    Get() {
      this.ActionsFilterGet({
        Service: this.$config.API_URL_2+"mznfirma",
        Page: this.Page,
        Filter: "&Firmaadi=" + this.FilterFirmaadi,
      }).then((res) => {
        this.TableData = res.Data;
        this.Page.PageDataSize = res.TotalCount;
      });
    },
  },
};
</script>

<template>
  <Loader>
    <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
        <div class="col-xl-12">
          <div class="card">
            <div class="card-body">
              <div class="row mb-2">
                <div class="col-sm-4">
                  <div class="search-box me-2 mb-2 d-inline-block">
                    <div class="position-relative">
                      <input type="text" @input="FilterFirmaadi.length >= 3 || FilterFirmaadi.length == 0 ? Get() : ''" v-model="FilterFirmaadi" class="form-control" :placeholder="$t('mznfirma.Page.Arama')" />
                      <i class="bx bx-search-alt search-icon"></i>
                    </div>
                  </div>
                </div>
                <div class="col-sm-8">
                  <div class="text-sm-end">
                   </div>
                </div>
              </div>
              <div class="table-responsive">
                <table class="table mb-0">
                  <thead class="table-light">
                    <tr>
                      <th>{{ $t("mznfirma.Table.Firmaadi") }}</th>
                      <th>{{ $t("mznfirma.Table.Telefon") }}</th>

                      <th style="width: 170px; text-align: center;">{{ $t("mznfirma.Table.Email") }}</th>
                      <th>{{ $t("mznfirma.Table.Vergino") }}</th>

                      <th style="width: 370px; text-align: center;">{{ $t("mznfirma.Table.Aciklama") }}</th>
                      <th style="text-align: center;">{{ $t("mznfirma.Table.Islem") }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="Data in TableData" :key="Data.Id">
                      <th scope="row">{{ Data.Firmaadi }}</th>
                      <td>{{ Data.Telefon }}</td>

                      <td>{{ Data.Email }}</td>
                      <td>{{ Data.Vergino }}</td>

                      <td>{{ Data.Aciklama }}</td>
                      <td style="width: 85px">
                        <b-button-group>
                          <b-button v-if="!Data.Onay " variant="warning" v-tooltip="$t('mznfirma.Table.Onay')" 
                          @click="FirmaOnay(Data)">
                            <i class="fas fa-check-double"></i>
                          </b-button>
                          <b-button variant="success" v-tooltip="$t('mznfirma.Table.Duzenle')" v-b-modal.mznfirma @click="(DataUpdate = Data), (AddEdit = 'Edit')">
                            <i class="far fa-edit"></i>
                          </b-button>

                          <b-button variant="danger" v-tooltip="$t('mznfirma.Table.Sil')" @click="UserDelete(Data)"><i class="far fa-trash-alt"></i></b-button>
                        </b-button-group>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <br />
                <b-pagination class="pagination pagination-rounded justify-content-end mb-2" v-model="DefaultPage" :total-rows="Page.PageDataSize" :per-page="Page.PageSize" aria-controls="my-table" @input="ChangePage(DefaultPage)"> </b-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
      <AddEdit :Id="DataUpdate" :AddEdit="AddEdit" @TableUpdate="Get" />
    </Layout>
  </Loader>
</template>
